import { EQ_OBTENER_COMPLETE } from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  listado: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case EQ_OBTENER_COMPLETE:
      return { ...state, listado: get(action, "payload") };
    default:
      return { ...state };
  }
}
